// extracted by mini-css-extract-plugin
module.exports = {"steakyHeader":"SteakyHeader_steakyHeader__1TFl5","open":"SteakyHeader_open__3G0lX"};